import script from "./DailyReconfirmedFollowupsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyReconfirmedFollowupsChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyReconfirmedFollowupsChart.vue?vue&type=style&index=0&id=d4227efa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4227efa"]])

export default __exports__